import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { Button, CircularProgress, Alert } from '@mui/material';
import PlayerStatistics, { PlayerStatisticsIdentity } from '../components/playerStatistics/PlayerStatistics';
import PlayerStatisticsLayout from '../components/playerStatistics/PlayerStatisticsLayout';
import { useEstadisticasJugadorAllSeasons, useJugador, useJugadorEstadisticasById } from '../hooks/queries';
import usePageTitle from '../hooks/usePageTitle';

export default function JugadorPageModern() {
  const { t } = useTranslation('players');
  usePageTitle(t('modern.title'));
  const navigate = useNavigate();
  const location = useLocation();
  const [params] = useSearchParams();
  const season = params.get('idTemporada');
  const id = params.get('id');
  const playerId = params.get('idJugador');
  const fromState = location.state?.jugador;
  const seasonQuery = useJugadorEstadisticasById(id, season, {
    enabled: !fromState && !playerId && Boolean(id && season),
  });
  // Old match links used a player ID where the seasonal endpoint expects a document ID.
  const lookupPlayer = Boolean(playerId || !season || (!seasonQuery.isError && !seasonQuery.isLoading
    && Array.isArray(seasonQuery.data) && !seasonQuery.data.length));
  const allSeasonsQuery = useEstadisticasJugadorAllSeasons(playerId || id, {
    enabled: !fromState && Boolean(playerId || id) && lookupPlayer,
  });
  const source = fromState || (!playerId && season ? seasonQuery.data?.[0] : null)
    || (lookupPlayer ? season ? allSeasonsQuery.data?.find(row => String(row.idTemporada) === season)
      : allSeasonsQuery.data?.reduce((latest, row) =>
        !latest || Number(row.idTemporada) > Number(latest.idTemporada) ? row : latest, null) : null);
  const ageQuery = useJugador(source?.idJugador || playerId || id, season, {
    enabled: Boolean(season && (source?.idJugador || playerId || id)),
  });
  const player = source ? { ...source, edad: ageQuery.data?.edad ?? source.edad } : null;
  const query = lookupPlayer ? allSeasonsQuery : seasonQuery;
  const loading = !fromState && query.isLoading;
  const error = !fromState && query.isError ? t('errors.loadData') :
    !loading && (playerId || id) && !player ? t('errors.noData') : null;
  const back = () => location.state?.directoryFrom
    ? navigate(location.state.directoryFrom) : navigate(-1);
  const retry = () => query.refetch();
  if (loading) return <div className="ps-loading" role="status" aria-label={t('modern.loading')}><CircularProgress /></div>;
  return <PlayerStatisticsLayout title={t('modern.title')} subtitle={t('modern.subtitle')} onBack={back}>
    {error && <Alert severity="error" action={<Button onClick={retry}>{t('errors.retry')}</Button>}>{error}</Alert>}
    {player ? <>
      <PlayerStatisticsIdentity jugador={player} season={season || player.idTemporada} profileLink />
      <PlayerStatistics jugador={player} />
    </> : <section className="dr-panel ps-section">
      <h2>{t('notFound.title')}</h2><p>{t('notFound.message')}</p><Button onClick={back}>{t('notFound.back')}</Button>
    </section>}
  </PlayerStatisticsLayout>;
}
